var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, useContext, } from 'react';
import { totalBorderOffset } from '../../styles/border';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { PickerOptionInputStateContext } from '../../utils/InputStateContext';
import { Icon, } from '../Icon';
import { PickerOption, } from '../Picker';
import { PickerContext } from '../Picker/PickerContext';
import { ShortTextPickerContext } from './ShortTextPickerContext';
const heights = {
    medium: 48 - totalBorderOffset,
    small: 36 - totalBorderOffset,
};
const iconSizes = {
    medium: 'small',
    small: 'extraSmall',
};
const labelStyles = css `
  ${theme.typeStyles.titleExtraSmallStyles}
`;
const ShortTextPickerOption = (_a) => {
    var { description, iconPlacement, iconType, label } = _a, pickerOptionProps = __rest(_a, ["description", "iconPlacement", "iconType", "label"]);
    const { isLoading, } = useContext(PickerContext);
    const { isDisabled = false, } = useContext(PickerOptionInputStateContext);
    const { size, } = useContext(ShortTextPickerContext);
    const optionStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        align-items: center;
        column-gap: ${theme.spacing.base};
        display: flex;
        height: ${styleUtils.rem(heights[size])};
        justify-content: center;
        text-align: center;
        white-space: nowrap;

        ${size === 'small' && css `
          padding-bottom: ${theme.spacing.base};
          padding-left: ${styleUtils.rem(2)};
          padding-right: ${styleUtils.rem(2)};
          padding-top: ${theme.spacing.base};
        `}
        ${size === 'medium' && css `
          padding-bottom: ${theme.spacing.x2};
          padding-left: ${theme.spacing.x2};
          padding-right: ${theme.spacing.x2};
          padding-top: ${theme.spacing.x2};
        `}
      `), [
        size,
    ]);
    const descriptionStyles = useMemo(() => (css `
        ${theme.typeStyles.bodyExtraSmallStyles}

        ${(isLoading || isDisabled) && css `
          color: ${theme.colors.textDisabled};
        `}
      `), [
        isLoading,
        isDisabled,
    ]);
    const iconComponent = useMemo(() => (_jsx("span", { children: _jsx(Icon, { size: iconSizes[size], type: iconType }) })), [
        iconType,
        size,
    ]);
    return (_jsx(PickerOption, Object.assign({}, pickerOptionProps, { children: _jsxs("div", Object.assign({ css: optionStyles }, { children: [iconType
                    && iconPlacement === 'left'
                    && iconComponent, _jsx("span", Object.assign({ css: labelStyles }, { children: label })), description
                    && (_jsx("span", Object.assign({ css: descriptionStyles }, { children: description }))), iconType
                    && iconPlacement === 'right'
                    && iconComponent] })) })));
};
const MemoizedShortTextPickerOption = memo(ShortTextPickerOption);
export { MemoizedShortTextPickerOption as ShortTextPickerOption };
// MC-1068 Temporary hack for Storybook.
export default ShortTextPickerOption;
